import Vue from 'vue';
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue';
import VueCompositionAPI from '@vue/composition-api';

import router from './router';
import store from './store';
import App from './App.vue';

// Global Components
import './global-components';

// 3rd party plugins
import '@/axios';
import '@/libs/portal-vue';
import '@/libs/toastification';
import '@/libs/sweet-alerts';

import moment from 'moment';
import 'moment/locale/tr'; // Türkçe dil desteği ekleyin

// Moment'i Türkçe'ye ayarlayın
moment.locale('tr');

Vue.prototype.$moment = moment; // Moment'i Vue prototype'ına ekleyin

// import globalFunc from '@core/utils/globalFunc';
// Vue.mixin(globalFunc);

import globalPlugin from '@core/utils/globalPlugin';
Vue.use(globalPlugin);

// *** Önemli Kısım: utilsMixin.js dosyasını dahil etme ve kullanma
import { utilsMixin } from '@core/utils/utilsMixin.js';
Vue.mixin(utilsMixin); // Mixin'i global olarak dahil ediyoruz.

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

require('@core/assets/fonts/feather/iconfont.css'); // For form-wizard

// import core styles
require('@core/scss/core.scss');

// import assets styles
require('@/assets/scss/style.scss');

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');